import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import KineticHero from "@/components/KineticHero";
import BrandStrip from "@/components/BrandStrip";
import ClientWall from "@/components/ClientWall";
import ServicesGrid from "@/components/ServicesGrid";
import AboutConnect from "@/components/AboutConnect";
import ProcessSection from "@/components/ProcessSection";
import ShowcaseGallery from "@/components/ShowcaseGallery";
import CtaBand from "@/components/CtaBand";
import EnquiryForm from "@/components/EnquiryForm";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import AdminPanel from "@/pages/AdminPanel";
import { Toaster } from "sonner";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen grid place-items-center bg-white text-royal font-body">
          Something went wrong. Please refresh the page.
        </div>
      );
    }
    return this.props.children;
  }
}

const Home = () => (
  <div className="grain relative bg-white text-royal font-body">
    <Navbar />
    <main>
      <KineticHero />
      <BrandStrip />
      <ClientWall />
      <ServicesGrid />
      <AboutConnect />
      <ProcessSection />
      <ShowcaseGallery />
      <CtaBand />
      <EnquiryForm />
    </main>
    <FloatingWhatsApp />
    <Footer />
  </div>
);

function App() {
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;

    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const target = document.querySelector(anchor.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -72 });
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      document.removeEventListener("click", onClick);
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminPanel />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="top-right" richColors closeButton />
    </ErrorBoundary>
  );
}

export default App;
